import { on } from 'delegated-events'
import { handleValidation } from '../scripts/common/validation.js'
import scrollTo from '../scripts/common/scrollTo.js'
import { handleAjaxSubmit } from '../scripts/components/styled-form.js'

export function initializeGiftForm() {
  const wrapper = document.querySelector('.gift-from-wrapper')
  const form = document.querySelector('.gift-form')
  const submitButton = form.querySelector('[type=submit]')
  const amountView = form.querySelector('.amount-view')
  const detailsView = form.querySelector('.details-view')
  const paymentView = form.querySelector('.payment-view')
  const amountField = form.querySelector('input[name=Amount]')
  const summaryFields = form.querySelectorAll('.payment-summary')

  const recurringLabels = {
    biweekly: '2 weeks',
    monthly: 'month',
    quarterly: '3 months',
    annually: 'year',
    biannually: '6 months',
  }

  const state = {
    view: 'amount',
    frequency: form.querySelector('input[name="Frequency"]:checked').value,
    recurringFrequency: form.querySelector('select[name="RecurringFrequency"]').value,
  }

  let stripe
  let elements
  let paymentIntentId

  const initializePaymentForm = async (form, type) => {
    stripe = window.Stripe(form.dataset.stripeKey)

    const appearance = {
      labels: "floating",
      theme: "stripe",
      variables: {
        colorPrimary: "#90722A",
        colorBackground: "#ffffff",
        colorDanger: "#DE1D1D",
        borderRadius: "0px",
      },
    }

    try {
      const endpoint = form.dataset.paymentEndpoint
      const pageTitle = document.title

      const data = new FormData(form)
      data.set("type", type)
      data.set("amount", parseFloat(amountField.value.replaceAll(',', '')))
      data.set("pageTitle", pageTitle)

      const res = await fetch(endpoint, {
        method: 'POST',
        body: data,
      }).then(response => response.json())

      elements = stripe.elements({ clientSecret: res.clientSecret, appearance })
      // Get the payment intent id during initialization
      paymentIntentId = res.id;

      const paymentElement = elements.create("payment", {
        layout: "tabs",
      })
      paymentElement.mount("#payment-element")


      // Show submit button after payment form is loaded
      setTimeout(() => {
        submitButton.style.opacity = 1
      }, 1000)

    } catch (error) {
      console.error(error)
    }
  }

  const render = () => {
    if (state.view === 'amount') {
      amountView.classList.add('is-active')
      detailsView.classList.remove('is-active')
      paymentView.classList.remove('is-active')
    }

    if (state.view === 'details') {
      amountView.classList.remove('is-active')
      detailsView.classList.add('is-active')
      paymentView.classList.remove('is-active')
    }

    if (state.view === 'payment') {
      amountView.classList.remove('is-active')
      detailsView.classList.remove('is-active')
      paymentView.classList.add('is-active')
    }

    let summary = `$ ${amountField.value}.00`

    if (state.frequency === 'Recurring') {
      summary = `${summary} every ${recurringLabels[state.recurringFrequency]}`
    }

    if (summaryFields) {
      summaryFields.forEach((field) => {
        field.value = summary
      })
    }

    scrollTo(wrapper)
  }

  const handlePaymentSubmit = async (e) => {
    e.preventDefault()

    const form = e.currentTarget
    const isValid = handleValidation(form)

    if (!isValid) {
      return
    }

    // Set the payment intent id in the hidden field
    let paymentIntentHiddenField = document.querySelector(".stripe-payment-intent-id");
    paymentIntentHiddenField.value = paymentIntentId;
    // Save the form data before handling the payment
    handleAjaxSubmit(e);

    const formData = new FormData(form)

    const billingDetails = {}

    billingDetails.name = `${formData.get("FirstName")} ${formData.get("LastName")}`
    billingDetails.email = formData.get("Email")
    billingDetails.phone = formData.get("Phone")
    billingDetails.address = {
      line1: formData.get("BillingAddress"),
      line2: formData.get("BillingAddress2"),
      city: formData.get("BillingCity"),
      state: formData.get("BillingState"),
    }

    submitButton.disabled = true
    submitButton.classList.add("is-loading")

    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: "https://www.herkimer.edu",
        payment_method_data: {
          billing_details: billingDetails,
        },
      },
      redirect: "if_required",
    })

    if (error && (error.type === "card_error" || error.type === "validation_error")) {
      showMessage(error.message)
      submitButton.disabled = false
      submitButton.classList.remove("is-loading")
    } else {
      showMessage("An unexpected error occurred.")
      submitButton.disabled = false
      submitButton.classList.remove("is-loading")
    }
  }

  function showMessage(messageText) {
    const messageContainer = document.querySelector("#payment-message")

    messageContainer.classList.remove("hidden")
    messageContainer.textContent = messageText

    setTimeout(function () {
      messageContainer.classList.add("hidden")
      messageContainer.textContent = ""
    }, 4000)
  }

  const init = () => {
    on('input', 'input[name=Amount]', (e) => {
      amountField.setAttribute('value', e.target.value)
    })

    on('click', '.donation-amount', (e) => {
      const amount = e.target.dataset.value

      // Remove active class from all other amounts
      document.querySelectorAll('.donation-amount').forEach((x) => x.classList.remove('is-active'))

      // Add active class to the selected amount
      e.target.classList.add('is-active')

      const updateEvent = new CustomEvent('updateValue', { detail: amount })

      amountField.dispatchEvent(updateEvent)

      amountField.setAttribute('value', amount)
    })

    on('click', 'input[name="Frequency"]', (e) => {
      if (e.target.checked) {
        state.frequency = e.target.value
      }
    })

    on('change', 'select[name="RecurringFrequency"]', (e) => {
      state.recurringFrequency = e.target.value
    })

    on('click', '.details-view-trigger', () => {
      const isValid = handleValidation(form)


      if (isValid) {
        state.view = 'details'

        render()
      }
    })

    on('click', '.amount-view-trigger', () => {
      state.view = 'amount'
      render()
    })

    on('click', '.payment-view-trigger', () => {
      const isValid = handleValidation(form)

      if (!isValid) {
        return
      }

      // Initially hide submit button until payment form is loaded
      submitButton.style.opacity = 0

      state.view = 'payment'
      render()

      if (!form) {
        return
      }

      const type = form.querySelector('input[name="Frequency"]:checked').value

      initializePaymentForm(form, type)

      form.addEventListener("submit", handlePaymentSubmit)
    })

  }

  init()
}

